import { useTranslation } from "react-i18next";
import SEO from "./common/SEO";

const About = ({ renderBody }) => {
  const { t, i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");
  const title = isEnglish ? "History & Founder Aldo Belli" : "Storia e Fondatore Aldo Belli";
  const desc = isEnglish
    ? "The story and origins of Nuova Orchestra da Camera Ferruccio Busoni, founded in Trieste in 1965 by Aldo Belli."
    : "La storia e le origini della Nuova Orchestra da Camera Ferruccio Busoni, fondata a Trieste nel 1965 da Aldo Belli.";

  return (
    <>
      <SEO title={title} description={desc} />
      <section className="section subpage-section">
        <div className="container subpage-container">
          {/* Chapter 1: Story of the Orchestra */}
          <div className="about-chapter mb-5">
            <div className="text-center mb-4">
              <h2 className="subpage-title">
                {isEnglish ? "Origins & Heritage" : "Origini & Identità"}
              </h2>
            </div>
            <div className="subpage-text-content about-lead-box p-4 rounded mb-5">
              {renderBody(t("about.intro"))}
            </div>
          </div>

          {/* Chapter 2: The Founder Aldo Belli */}
          <div className="about-chapter mb-5 pt-3">
            <div className="text-center mb-4">
              <h2 className="subpage-title">Aldo Belli (1927 – 2006)</h2>
            </div>

            <div className="card border-0 shadow-sm rounded-4 p-4 p-lg-5 about-founder-card">
              <div className="row align-items-center g-4">
                <div className="col-lg-5 text-center">
                  <div className="founder-img-wrapper d-inline-block mb-3">
                    <img
                      src="https://res.cloudinary.com/orchestrabusoni/image/upload/v1647612072/AldoBelli_r3ivxl.jpg"
                      alt="Aldo Belli, fondatore dell'Orchestra Busoni"
                      className="img-fluid rounded-4 shadow-sm"
                      style={{ maxHeight: "380px", objectFit: "cover" }}
                      loading="lazy"
                    />
                  </div>
                  <div className="text-muted small">
                    <div className="fw-semibold text-dark">
                      {isEnglish
                        ? "Prima Viola Teatro Verdi & Founder M° Aldo Belli"
                        : "Prima Viola Teatro Verdi & Fondatore M° Aldo Belli"}
                    </div>
                    <div className="mt-1 font-italic">
                      Viola Marino Capicchioni (1947)
                    </div>
                  </div>
                </div>

                <div className="col-lg-7">
                  <div className="subpage-text-content text-start">
                    {renderBody(t("about.aldo_belli_bio"))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Chapter 3: Historic Photographic Archive */}
          <div className="about-chapter mt-5 pt-3">
            <div className="text-center mb-4">
              <h2 className="subpage-title">
                {t("about.pic_title")}
              </h2>
            </div>

            <div className="row g-4 mt-2">
              <div className="col-md-6">
                <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden gallery-card">
                  <div className="gallery-img-box">
                    <img
                      src="https://res.cloudinary.com/orchestrabusoni/image/upload/v1647612101/slide77_BusoniOld_IstitutoGermanico0_iwfuva.png"
                      alt="Foto storica Orchestra Busoni - Istituto Germanico"
                      className="img-fluid w-100 hoverzoom"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-body p-3 text-center bg-white">
                    <span className="small text-muted fw-semibold">
                      {isEnglish
                        ? "Concert at the German Cultural Institute"
                        : "Concerto all'Istituto Germanico"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden gallery-card">
                  <div className="gallery-img-box">
                    <img
                      src="https://res.cloudinary.com/orchestrabusoni/image/upload/v1647612106/slide77_BusoniOld_IstitutoGermanico1_spccz9.png"
                      alt="Foto d'archivio Orchestra Busoni"
                      className="img-fluid w-100 hoverzoom"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-body p-3 text-center bg-white">
                    <span className="small text-muted fw-semibold">
                      {isEnglish
                        ? "Historical performance of the Busoni Chamber Orchestra"
                        : "Esecuzione storica dell'Orchestra da Camera Busoni"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
